
/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { AuthnTransaction, OktaAuth, UserClaims } from '@okta/okta-auth-js'
import { EventEmitter, Inject, Injectable, InjectionToken, Optional } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { OktaProvider, OktaFactorType } from '../../models'
import { CacheService, PreviewModeSessionKeys } from '../../../../src/commons/services/business/cache.service'
import { TelemetryService } from '../telemetry'
import { API_CONFIG } from '../users/userApi.service'
import { IApiConfig } from '@sightline/models-misc'

export const OKTA_CONFIG = new InjectionToken<IOktaConfig>('OktaConfig')

export interface IOktaConfig {
  clientId: string
  issuer: string
  scopes: string[]
}

/** What the API answers for a challenge, plus what identifies the factor on the call after it. */
export interface IMfaChallenge {
  stateToken: string
  factorType: string
  provider: string
  sent?: boolean
  /** Already masked by Okta, e.g. "+1 XXX-XXX-8390". */
  target?: string
  availableFactors?: string[]
}

export interface IMfaVerification {
  verified: boolean
  status?: string
  sessionToken?: string
}

/** Claims served in preview, so no call to Okta is needed to know who is "signed in". */
const PREVIEW_USER = {
  sub: 'preview',
  name: 'John Smith',
  given_name: 'John',
  family_name: 'Smith',
  preferred_username: 'preview-john-smith',
  locale: 'en_US',
  zoneinfo: 'America/Los_Angeles',
} as UserClaims

export const FREQUENCY = 1000 // 1 sec
const MAX_IDLE_TIME_BEFORE_OPEN_DIALOG = 780 //13 minutes in seconds
const COUNTDOWN_SECONDS = 120

@Injectable({
  providedIn: 'root',
})
export class AuthWrapperService {
  private _config: IOktaConfig
  private _checkIntervalSession

  private S_SLP_SESSION_COUNTDOWN_TIME = 'sslp-sct'
  private S_SLP_IDLE_TIME = 'sslp-it'
  private S_SLP_IDLE_MODAL_IS_ACTIVE = 'sslp-imia'
  private S_SLP_CONTDOWN_TIME = 'sslp-ct'
  private S_OKTA_STORAGE = 'okta-token-storage'

  public onInactive = new EventEmitter()
  public onActive = new EventEmitter()
  public countDownToLogout: string

  private nonce: string

  get hasLoggedInPreviewMode() : boolean {
     return JSON.parse(sessionStorage.getItem(PreviewModeSessionKeys.SLP_PREVIEW_IS_LOGGED_IN)) === true
  }

  get isPreviewMode(): boolean {
    return JSON.parse(sessionStorage.getItem(PreviewModeSessionKeys.SLP_PREVIEW_MODE)) === true
  }

  get idleTimeToOpenModal(): number {
    return Number.parseInt(localStorage.getItem(this.S_SLP_IDLE_TIME))
  }

  set idleTimeToOpenModal(value: number) {
    localStorage.setItem(this.S_SLP_IDLE_TIME, value.toString())
  }

  get idleModalIsActive(): string {
    return localStorage.getItem(this.S_SLP_IDLE_MODAL_IS_ACTIVE)
  }

  set idleModalIsActive(value: string) {
    localStorage.setItem(this.S_SLP_IDLE_MODAL_IS_ACTIVE, value)
  }

  get isContdownTimeStarted(): string {
    return localStorage.getItem(this.S_SLP_CONTDOWN_TIME)
  }

  set isContdownTimeStarted(value: string) {
    localStorage.setItem(this.S_SLP_CONTDOWN_TIME, value)
  }

  private _authClient: OktaAuth

  get authClient(): OktaAuth {
    return this._authClient
  }

  set authClient(value: OktaAuth) {
    this._authClient = value
  }

  constructor(private httpClient: HttpClient, private cacheService: CacheService, private telemetry: TelemetryService, @Inject(OKTA_CONFIG) @Optional() config?: IOktaConfig, @Inject(API_CONFIG) @Optional() private apiConfig?: IApiConfig) {
    this._config = config
    this.authClient = new OktaAuth(this._config)
  }

  private apiUrl(path: string): string {
    return `${this.apiConfig?.url ?? '/api'}/${path}`
  }

  private get apiHeaders(): Record<string, string> {
    return { 'api-version': this.apiConfig?.version ?? '1.0' }
  }

  public async login(username: string, password: string): Promise<AuthnTransaction> {
    try {
      if (this.isPreviewMode) {
        const previewToken = this.cacheService.getPreviewToken()
        this.cacheService.setHasLoggedInPreviewMode(true)
        this.setAccessToken({
          accessToken: {
            accessToken: previewToken,
            tokenType: 'Bearer'
          }
        })
        return Promise.resolve({
          stateToken: previewToken,
          expiresAt: '2028-10-23T02:20:53.000Z',
          status: 'MFA_REQUIRED',
          user: {
            id: '00u6d7xxjd3EiRsAa697',
            passwordChanged: '2023-07-11T14:43:10.000Z',
            profile: {
              login: 'dslp-John_smith',
              firstName: 'John',
              lastName: 'Smith',
              locale: 'en_US',
              timeZone: 'America/Los_Angeles'
            }
          },
          profile: {
            email: 'johnSmith@sightlinepayments.com',
            updatePhone: false
          },
        })
      }

      await this.clearAnyExistingSession()
      const response = await this.authClient.signIn({
        username: username,
        password: password,
      })
      if (response.status === 'SUCCESS') {
        await this.initSession(response)
      }

      return response
    } catch (error) {
      console.log(error)
    }
  }

  async clearAnyExistingSession() {
    const session = await this.authClient.session.get()
    if (session && session.status !== 'INACTIVE') {
      await this.authClient.revokeAccessToken()
      await this.authClient.closeSession()
    }
    this.cacheService.clearLocalStorageCache()
    this.clearLocalStorageKeys()
  }

  /**
   * Asks the API to send the code. The browser no longer talks to Okta here, which is what
   * gives the step a server-side trace, and it also removes the custom-domain rewrite that
   * used to be applied to the Okta URL on the way out.
   */
  public async requestMfaCode(authTransaction: AuthnTransaction, factorType: OktaFactorType, provider: OktaProvider, _oktaCustomDomain?: string): Promise<IMfaChallenge> {
    const stateToken = (authTransaction as any).data.stateToken
    const authData = (authTransaction as any).data._embedded
    const wanted = `${factorType}:${provider}`

    this.telemetry.event('mfa.factors_received', {
      wanted: wanted,
      offered: (authData?.factors ?? []).map(q => `${q.factorType}:${q.provider}`).join(','),
    })

    this.telemetry.event('mfa.request_code.start', { wanted: wanted })

    try {
      const challenge = await this.httpClient.post<IMfaChallenge>(
        this.apiUrl('mfa/challenge'),
        { stateToken: stateToken, factorType: factorType, provider: provider },
        { headers: this.apiHeaders },
      ).toPromise()

      this.telemetry.event('mfa.request_code.ok', { wanted: wanted, target: `${challenge?.target ?? ''}` })

      return { ...challenge, stateToken: stateToken, factorType: factorType, provider: provider }
    }
    catch (error) {
      this.telemetry.event('mfa.request_code.failed', {
        wanted: wanted,
        status: `${error?.status ?? 'none'}`,
        message: `${error?.error?.error ?? error?.message ?? ''}`,
      })
      throw error
    }
  }

  private hostOf(url: string): string {
    try {
      return new URL(url).host
    } catch {
      return '(unparseable)'
    }
  }

  /** Resending is the same challenge again, so there is no second path to keep working. */
  public async resendMfaCode(challenge: IMfaChallenge, _oktaCustomDomain?: string): Promise<IMfaChallenge> {
    const result = await this.httpClient.post<IMfaChallenge>(
      this.apiUrl('mfa/challenge'),
      { stateToken: challenge.stateToken, factorType: challenge.factorType, provider: challenge.provider },
      { headers: this.apiHeaders },
    ).toPromise()

    return { ...result, ...challenge }
  }

  public getOktaCustomDomain(oktaUrl: string, customBrandOktaUrl: string): string {
    if (customBrandOktaUrl) {
      const path = '/api/' + oktaUrl.split('/api')[1]
      return customBrandOktaUrl + path
    } else {
      return oktaUrl
    }
  }

  public async activateMfaCode(challenge: IMfaChallenge, passCode: string): Promise<boolean> {
    try {
      const result = await this.httpClient.post<IMfaVerification>(
        this.apiUrl('mfa/verify'),
        {
          stateToken: challenge.stateToken,
          factorType: challenge.factorType,
          provider: challenge.provider,
          passCode: passCode,
        },
        { headers: this.apiHeaders },
      ).toPromise()

      this.telemetry.event('mfa.verify', { status: `${result?.status ?? 'none'}` })

      if (!result?.verified) return false

      // Exchanging the session token for tokens happens against the browser's own Okta client.
      await this.initSession({ sessionToken: result.sessionToken } as AuthnTransaction)

      return true
    }
    catch (error) {
      this.telemetry.event('mfa.verify.failed', { message: `${error?.message ?? ''}` })
      return false
    }
  }

  async initSession(authTransaction: AuthnTransaction): Promise<void> {
    const tokens = await this.authClient.token.getWithoutPrompt({
      clientId: this._config.clientId,
      responseType: ['id_token', 'token'],
      scopes: this._config.scopes,
      sessionToken: authTransaction.sessionToken,
      nonce: this.nonce,
      redirectUri: window.location.origin + '/login/callback',
    })
    this.authClient.tokenManager.setTokens(tokens.tokens)
    this.start()
  }

  clearLocalStorageKeys(): void {
    Object.keys(localStorage)
      .filter((x) => x.startsWith('sslp'))
      .forEach((x) => localStorage.removeItem(x))
  }

  public async logOut(): Promise<void> {
    this.end()

    // Preview has no Okta session to close, and reaching for one only produces a failed
    // cross-origin call from whatever host the preview is being served from.
    if (this.isPreviewMode) {
      this.cacheService.setHasLoggedInPreviewMode(false)
      return
    }

    if (!(await this.isTheSameSession())) {
      localStorage.removeItem(this.S_OKTA_STORAGE)
      window.location.href = window.location.origin + '/auth/login'
      return
    }
    await this.authClient.signOut({
      revokeAccessToken: true,
      clearTokensBeforeRedirect: true,
      postLogoutRedirectUri: document.baseURI,
    })

    if(this.isPreviewMode) {
      this.cacheService.setHasLoggedInPreviewMode(false)
    }
  }

  public getAccessToken(): string {
    const token = localStorage.getItem(this.S_OKTA_STORAGE)
    if (!token)
      return ''

    try {
      const tokenParsed = JSON.parse(token)
      return tokenParsed?.accessToken?.accessToken ?? ''
    } catch {
      return ''
    }
  }

  public setAccessToken(token): void {
    const t = JSON.stringify(token)
    localStorage.setItem(this.S_OKTA_STORAGE, t)
  }

  public getJwtTokenParsed(): any {
    const token = this.getAccessToken()
    const base64Url = token.split('.')[1]
    if (!base64Url)
      return null

    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const json = decodeURIComponent(window.atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))

    return JSON.parse(json)
  }

  public async getUser(): Promise<UserClaims> {
    if (this.isPreviewMode) return PREVIEW_USER

    return this.authClient.getUser()
  }

  /**
   * In preview the only thing that says "signed in" is the preview flag. Asking Okta as well
   * means a cross-origin call to the Okta domain, which fails from any host that is not a
   * registered trusted origin, and that failure cascades: the interceptor sees the error and
   * clears the preview session.
   */
  public async isAuthenticated(): Promise<boolean> {
    if (this.isPreviewMode) return this.hasLoggedInPreviewMode

    return await this.authClient.isAuthenticated()
  }

  //this is a workaround because okta uses cookies to handle the session
  //ref: https://github.com/okta/okta-auth-js#third-party-cookies
  public async isTheSameSession() {
    if (this.isPreviewMode) return true

    try {
      const token = this.getJwtTokenParsed()
      const session = await this.authClient.session.get()

      if (session && (session as any).login !== token.sub)
        return false

      return true
    }
    catch {
      return false
    }
  }

  public async refreshToken(): Promise<void> {
    // Nothing to refresh: the preview token is the credential and it does not expire mid-session.
    if (this.isPreviewMode) return

    if (!(await this.isTheSameSession()))
      return

    await this.authClient.session.refresh()
    const tokens = await this.authClient.token.getWithoutPrompt({
      redirectUri: window.location.origin + '/login/callback',
    })
    this.authClient.tokenManager.setTokens(tokens.tokens)
    this.start()
  }

  public start(): void {
    if (!this._checkIntervalSession) {
      this.resetIdleTime()
      this._checkIntervalSession = setInterval(() => this.checkSessionInactivity(), FREQUENCY)
      this.resetIdleTimeOnUserAction()
    }
  }

  public checkSessionInactivity(): void {
    if ((new Date(this.idleTimeToOpenModal) < new Date() || this.idleModalIsActive) && !this.isPreviewMode) {
      if (!this.isContdownTimeStarted) {
        localStorage.setItem(this.S_SLP_SESSION_COUNTDOWN_TIME, new Date().getTime().toString())
        this.idleModalIsActive = 'true'
        this.isContdownTimeStarted = 'true'
      }

      const timer = this.getTimer()
      this.countDownToLogout = this.getCountDownFormatted(timer)

      if (timer <= 0) {
        sessionStorage.setItem('showTimeoutMessage', 'true')
        this.logOut()
      }

      this.onInactive.next(true)
    } else {
      this.onActive.next(true)
    }
  }

  public renewIdleSession(): void {
    this.idleModalIsActive = ''
    this.isContdownTimeStarted = ''
  }

  public getTimer(): number {
    const timeout = new Date(Number.parseInt(localStorage.getItem(this.S_SLP_SESSION_COUNTDOWN_TIME)))
    timeout.setSeconds(timeout.getSeconds() + COUNTDOWN_SECONDS)
    let timer = Math.round(new Date(timeout.getTime() - new Date().getTime()).getTime() / 1000)
    if (timer < 0 || isNaN(timer))
      timer = 0

    return timer
  }

  public getCountDownFormatted(timer: number): string {
    const minutes = this.getMinutesFormatted(timer)
    const seconds = this.getSecondsFormatted(timer)
    return `${minutes} : ${seconds}`
  }

  private getMinutesFormatted(timer: number): string {
    let minutes
    minutes = parseInt((timer / 60).toString(), 10)
    minutes = minutes < 10 ? '0' + minutes : minutes
    return minutes
  }

  private getSecondsFormatted(timer: number): string {
    let seconds
    seconds = parseInt((timer % 60).toString(), 10)
    seconds = seconds < 10 ? '0' + seconds : seconds
    return seconds
  }

  public resetIdleTime = (): void => {
    const currentDate = new Date()
    currentDate.setSeconds(currentDate.getSeconds() + MAX_IDLE_TIME_BEFORE_OPEN_DIALOG)
    this.idleTimeToOpenModal = currentDate.getTime()
  }

  private resetIdleTimeOnUserAction() {
    window.addEventListener('keypress', this.resetIdleTime)
    window.addEventListener('click', this.resetIdleTime)
  }

  public end(): void {
    this.resetIdleTime()
    clearInterval(this._checkIntervalSession)
  }
}
